import { motion } from 'framer-motion';

export const Reveal = ({ children, delay = 0, y = 28, className = '', ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-70px' }}
    transition={{ duration: 0.75, delay, ease: [0.16, 1, 0.3, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, dark = false }) => (
  <p
    className={`font-mono text-xs uppercase tracking-[0.28em] ${
      dark ? 'text-brand' : 'text-brand'
    }`}
  >
    {children}
  </p>
);
